<ds-modal
  [modal]="modal"
  [title]="title"
  [maxWidthPercentage]="maxWidthPercentage"
  (modalClosed)="onClose()"
  [closeAllModals]="closeAllModals"
>
  @if (message) {
    <p data-test-id="ds-modal-message" class="message">{{ message }}</p>
  }
  @if (description) {
    @if (descriptionIsHTML) {
      <p data-test-id="ds-modal-description" [innerHTML]="description"></p>
    } @else {
      <p data-test-id="ds-modal-description">{{ description }}</p>
    }
  }

  <ds-button-group
    [primaryAction]="{ label: confirmLabel || 'label_confirm' | translate }"
    [secondAction]="{
      label: cancelLabel || 'form_cancel' | translate,
      variant: hideCancelButton ? null : DsButtonVariants.secondary,
    }"
    (primaryActionClicked)="onConfirm()"
    (secondActionClicked)="onCancel()"
  >
  </ds-button-group>
</ds-modal>
